import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmployeeAreaList } from "../../Types/EmployeeInterface";
import { getContactAreaList } from "../../Thunks/contactThunks";

interface ContactAreaSliceState {
    loader: boolean; // for refres pages and inital loadings
    loaded: boolean;
    areaList: EmployeeAreaList [];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ContactAreaSliceState = {
    loader: false,
    loaded: false,
    areaList: [],
    errorDisplay: '',

}

// set state valu for api response
const contactAreaSlice = createSlice ({
    name: 'contactAreaSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getContactAreaList.rejected, (state, action) => {
                    state.loader = false;
                    state.loaded = false;
                    state.errorDisplay = action.payload || action.error.message || 'Unable to load contact areas';
                  })
                    .addCase(getContactAreaList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getContactAreaList.fulfilled, (state, action: PayloadAction<EmployeeAreaList[]>) => {
                    state.loader = false;
                    state.loaded = true;
                    state.areaList = action.payload;
                  })
    }
})

export default contactAreaSlice.reducer
